module.exports = __webpack_public_path__ + "media/music/bells_5-bc711545.mp3";